import React, { useState, useEffect } from 'react';
import {MultiSelect} from 'react-multi-select-component';

const MultiMonths: React.FC = (props) => {
  let stores = [];

  //alert(JSON.stringify(props.options.cityInfos));
  let label = '';

  label = 'months';
  stores = JSON.parse(props.options);
  let storesData = [];
  let NotCheckedStoresData = [];
  stores.map((val, index) => {
    if (parseInt(val.currentMonth) === 1) {
      storesData.push({
        label: val.label,
        value: val.value,
      });
    }

    NotCheckedStoresData.push({
      label: val.label,
      value: val.value,
    });
  });
  // initialInput = [{ label: monthNames[date.getMonth()], value: month }];
  //options = props.options;

  const [selected, setSelected] = useState(storesData);
  const selection = (e) => {
    setSelected(e);
    props.handleMonthChange(e);
  };
  return (
    <div>
      <MultiSelect
        className='multiSelectAll'
        options={NotCheckedStoresData}
        value={selected}
        onChange={selection}
        overrideStrings={{
          clearSearch: 'Clear Search',
          noOptions: 'No options',
          selectSomeItems: `Search for ${label}`,
          allItemsAreSelected: `All ${label} are selected.`,
          selectAll: 'Select All',
          search: 'Search',
        }}
      />
      {props.selectFor === 'month'
        ? localStorage.setItem(
            'multiMonthSelected',
            JSON.stringify({
              type: props.selectFor,
              data: JSON.stringify(selected),
            })
          )
        : ''}
    </div>
  );
};

export default MultiMonths;

/*import React from 'react';
import Select from 'react-select';

 const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
]; */

/* class DataDownLoad extends React.Component {
  constructor(props) {
    super(props);
    //const options = [];
    this.state = {
      selectedOption: null,
      options: [],
    };
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });

    console.log(`Option selected:`, selectedOption);
  };
  render() {
    const { selectedOption } = this.state;
    if (this.props.options.cityInfos) {
      this.props.options.cityInfos.map((val) => {
        this.state.options.push({
          label: val.cityName,
          value: val.cityId,
        });
      });
    }

    return (
      <Select
        value={selectedOption}
        onChange={this.handleChange}
        options={this.state.options}
        isMulti
      />
    );
  }
}
export default DataDownLoad; */
